import React from "react";
import ReactCountryFlag from "react-country-flag";
import { globs } from "../../components/utils/utils";

export default class PhoneInput extends React.Component {
  dropdownRef = React.createRef();
  state = {
    selectedCountry: "us",
    countryCode: "+1",
    mobilePhone: "",
    showDropdown: false,
    phoneError: "", 
    countries: [
      { iso: "us", code: "+1", label: "United States" },
      { iso: "ca", code: "+1", label: "Canada" },
      { iso: "mx", code: "+52", label: "Mexico" },
      // { iso: "pk", code: "+92", label: "Pakistan" },
    ],
  };

componentDidMount() {
  document.addEventListener("mousedown", this.handleClickOutside);
    const { selectedCountry, countryCode, mobilePhone } = this.props;
  this.setState({
    selectedCountry: selectedCountry || "us",
    countryCode: countryCode || "+1",
    mobilePhone: mobilePhone || "",
  })
}
componentWillUnmount() {
  document.removeEventListener("mousedown", this.handleClickOutside);
}
 componentDidUpdate(prevProps) {
  if (
    prevProps.mobilePhone !== this.props.mobilePhone ||
    prevProps.countryCode !== this.props.countryCode ||
    prevProps.selectedCountry !== this.props.selectedCountry
  ) {
    this.setState({
      mobilePhone: this.props.mobilePhone || "",
      countryCode: this.props.countryCode || "+1",
      selectedCountry: this.props.selectedCountry || "us",
    });
  }
}

handleClickOutside = (event) => {
  if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
    this.setState({ showDropdown: false });
  }
};

  handleCountrySelect = (iso) => {
    const c = this.state.countries.find((x) => x.iso === iso);
    this.setState({
      selectedCountry: iso,
      countryCode: c.code,
      showDropdown: false,
    });
  };

  handlePhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 10);
    const valid = !val || val.length === 10;
    const fullNumber = `${this.state.countryCode}${val}`;

     let phoneError = "";
    if (val && val.length < 10) {
      phoneError = "Phone number must be 10-digits.";
    }
 
    if (this.props.clearMobileError) {
    this.props.clearMobileError();
    }
    if (globs?.events?.publish) {
      globs.events.publish(
        "savePageEnable",
        valid && this.state.mobilePhone !== val
      );
    }

    this.setState({ mobilePhone: val , phoneError });

    if (this.props.onChange) {
      this.props.onChange({
        fullNumber,
        countryCode: this.state.countryCode,
        mobilePhone: val,
        countryIso: this.state.selectedCountry, 
      });
    }
  };

  render() {
    const { countries, selectedCountry, showDropdown, mobilePhone, phoneError } = this.state;
    const current = countries.find((c) => c.iso === selectedCountry);
    const isRegister = window.location.pathname.includes("register");
    return (
    <div ref={this.dropdownRef} translate="no" style={{ position: "relative", width: "100%", maxWidth: isRegister ? "100%" : 230, }}>
  {/* <label
    htmlFor="mobilePhone"
    style={{
      display: "block",
      fontWeight: 600,
      marginBottom: 8,
      color: "#333",
    }}
  >
    Mobile Phone Number for SMS
  </label> */}

  <div
    style={{
      display: "flex",
      alignItems: "center",
      border: "1px solid #aaa",
      borderRadius: 10,
      paddingLeft: 8,
      paddingRight: 8, 
      height: 38,
      background: "#fff",
      boxSizing: "border-box",
      overflow: "hidden", 
    }}
  >
    {/* Flag Dropdown */}
    <div
      onClick={() => this.setState({ showDropdown: !showDropdown })}
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      <ReactCountryFlag
        countryCode={current?.iso.toUpperCase() || "US"}
        svg
        style={{ width: 20, height: 20, borderRadius: 3 }}
      />
     <span className="material-icons" style={{ fontSize: 18, color: "#555", marginLeft: isRegister ?"10px":"-10px" }}>expand_more</span>
    </div>

    {/* Input */}
    <input
      id="account-cell"
      type="tel"
      maxLength="10"
      placeholder="Enter mobile number"
      value={mobilePhone}
      onChange={this.handlePhoneChange}
      style={{
        flex: 1,
        border: "none",
        outline: "none",
        fontSize: 14,
        color: "#333",
        height: "100%",
        background: "transparent",
        fontFamily: "inherit",
        boxSizing: "border-box",
        paddingRight: 4,
      }}
      className="phone-input"
    />
  </div>
      {phoneError && (
          <div
            style={{
              color: "#ff4d4f",
              fontSize: "13px",
              marginTop: "6px",
              fontWeight: 500,
            }}
          >
            {phoneError}
          </div>
        )}

  {/* Dropdown */}
  {showDropdown && (
    <div
      style={{
        position: "absolute",
        top: "calc(100% + 4px)",
        left: 0,
        width: "100%",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: 6,
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        zIndex: 10,
      }}
    >
      {countries.map((c) => (
        <div
          key={c.iso}
          onClick={() => this.handleCountrySelect(c.iso)}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 10px",
            cursor: "pointer",
            background: c.iso === selectedCountry ? "#f5f5f5" : "transparent",
          }}
        >
          <ReactCountryFlag
            countryCode={c.iso.toUpperCase()}
            svg
            style={{ width: 20, height: 20, marginRight: 8 }}
          />
          <span style={{ fontSize: 14, color: "#333" }}>{c.label}</span>
        </div>
      ))}
    </div>
  )}
</div>


    );
  }
}
